import { render, staticRenderFns } from "./CategoryNameAndDescCard.vue?vue&type=template&id=45bf40d9&scoped=true&"
import script from "./CategoryNameAndDescCard.vue?vue&type=script&lang=js&"
export * from "./CategoryNameAndDescCard.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNameAndDescCard.vue?vue&type=style&index=0&id=45bf40d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf40d9",
  null
  
)

export default component.exports